
// color-code sensor generations so Gen3 stands out from the current Gen4 fleet
// kept in a .tsx file: tailwind only scans src/**/*.tsx for class names
export const getSensorGenerationColors = (
  generation: number
): { text: string; border: string; background: string } => {
  switch (generation) {
    case 3:
      return {
        text: "text-endeavour",
        border: "border-endeavour",
        background: "bg-endeavour/10",
      };
    default:
      return {
        text: "text-pelorous",
        border: "border-pelorous",
        background: "bg-pelorous/10",
      };
  }
};

interface SensorGenerationBadgeProps {
  generation: number | null | undefined;
  className?: string;
}

const SensorGenerationBadge = ({
  generation,
  className,
}: SensorGenerationBadgeProps) => {
  if (!generation) return null;

  const { text, border, background } = getSensorGenerationColors(generation);

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 text-xs leading-5 font-semibold ${text} ${border} ${background} ${
        className ?? ""
      }`}
    >
      Gen {generation}
    </span>
  );
};

export default SensorGenerationBadge;
